import { ELEMENT_TYPE, Track } from "../utils/utils";
import { Condition } from "./condition";
import { FootNote } from "./footNote";

const arrow = require("../assets/images/Arrow_Long_Right.svg");
const close = require("../assets/images/conditionPopup/Close.svg");
export class Requirement {
  constructor(id, name, label, hint, checked, param_name, conditions, forms, refs, footNotes, items) {
    this.id = id;
    this.name = name;
    this.label = label;
    this.hint = hint;
    this.checked = checked;
    this.paramName = param_name;
    this.conditions = conditions;
    this.footNotes = footNotes
    this.forms = forms;
    this.refs = refs;
    this.items = items;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Requirement(input.code, input.name, input.name, input.hint, input.is_applied, input.param_name, Condition.fromApiArray(input.conditions), input.forms || [], input.refs || [], FootNote.fromApiArray(input.foot_notes), Requirement.fromApiArray(input.items))
    }
    return new Requirement();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Requirement.fromApiObject(item));
    }
    if (input && typeof (input) === "object") {
      return [Requirement.fromApiObject(input)];
    }
    return [];
  }

  genHtml(latest = false) {
    let translate = window.searchData.destination === "NO" ? ' class="translate"' : "";

    let html = "";
    let hint = '';
    if (this.hint && this.hint !== this.label) {
      hint = `<div class="instruction">
          <div class="dropdown">
            <div class="content">
              ${this.hint}
            </div>
          </div>
        </div>`;
    }
    if (this.items.length) {
      html = `
        <tr class="item group">
          <td colspan=4${translate}>${this.label}${hint}</td>
        </tr>
      `
      this.items.forEach((item, index) => {
        html += item.genHtml(index === this.items.length - 1);
      });
      return html;
    }
    let detail = "";
    if (this.conditions.length) {
      let body = `<div class="condition-items">`;
      this.conditions.forEach(element => {

        let table = "";

        element.requirements.forEach(e => {
          table += `
            <tr>
              <td>${e.documentCode}</td>
              <td>${e.requirement}</td>
              <td>${e.action}</td>
            </tr>
          `
        });

        body += `
          <div class="condition-item">
            <div class="condition-title">${element.name}</div>
            <div class="condition-detail">
              <table>
                <thead>
                  <tr>
                    <th>Document Code</th>
                    <th>Requirement</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  ${table}
                </tbody>
              </table>
            </div>
          </div>
        `
      });

      body += `</div>`

      const tfc = Track.genNormalTrack("", "requirement", "condition-" + this.id, ELEMENT_TYPE.A, "", 3000, 0, 1);
      const tfh = Track.genNormalTrack("", "requirement", "condition-" + this.id, ELEMENT_TYPE.A, "", 3000, 0, 1);

      detail = `
        <a tfc='${tfc}' tfh='${tfh}' class="detail-link" data-toggle="modal" data-target="#condition-${this.id}">Condition</a>
        <div class="modal fade" id="condition-${this.id}" tabindex="-1" role="dialog" aria-labelledby="condition-${this.id}-Label" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="condition-${this.id}-Label">${this.name}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <img alt="close" src="${close}"/>
                </button>
              </div>
              <div class="modal-body">
                ${body}
              </div>
            </div>
          </div>
        </div>
      `;
    }

    // let footNote = "";
    // if (this.footNotes.length) {
    //   let body = `<div class="condition-items">`;
    //   this.footNotes.forEach(element => {

    //     let table = "";

    //     element.details.forEach(e => {
    //       table += `
    //         <tr>
    //           <td>${e.code}</td>
    //           <td>${e.description}</td>
    //         </tr>
    //       `
    //     });

    //     body += `
    //       <div class="condition-item">
    //         <div class="condition-detail">
    //           <table>
    //             <thead>
    //               <tr>
    //                 <th>Code</th>
    //                 <th>Description</th>
    //               </tr>
    //             </thead>
    //             <tbody>
    //               ${table}
    //             </tbody>
    //           </table>
    //         </div>
    //       </div>
    //     `
    //   });

    //   body += `</div>`

    //   footNote = `
    //     <a class="detail-link" data-toggle="modal" data-target="#foot-note-${this.id}">
    //       Learn more
    //       <img alt="arrow" src="${arrow}" />
    //     </a>
    //     <div class="modal fade" id="foot-note-${this.id}" tabindex="-1" role="dialog" aria-labelledby="foot-note-${this.id}-Label" aria-hidden="true">
    //       <div class="modal-dialog" role="document">
    //         <div class="modal-content">
    //           <div class="modal-header">
    //             <h5 class="modal-title" id="foot-note-${this.id}-Label">${this.name}</h5>
    //             <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    //               <img alt="close" src="${close}"/>
    //             </button>
    //           </div>
    //           <div class="modal-body">
    //             ${body}
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   `;
    // }

    let form = "";
    this.forms.forEach(e => {
      if (e) {
        const tfc = Track.genNormalTrack("", "requirement", "form-" + e, ELEMENT_TYPE.A, "", 3000, 0, 1);
        const tfh = Track.genNormalTrack("", "requirement", "form-" + e, ELEMENT_TYPE.A, "", 3000, 0, 1);
        form += `
          <a tfc='${tfc}' tfh='${tfh}' target="_blank" class="co-form" href="${e}">
            C/O Form
            <img alt="arrow" src="${arrow}" />
          </a>
        `;
      }
    });

    let ref = "";

    this.refs.forEach(e => {
      const tfc = Track.genNormalTrack("", "requirement", "ref-" + e, ELEMENT_TYPE.A, "", 3000, 0, 1);
      const tfh = Track.genNormalTrack("", "requirement", "ref-" + e, ELEMENT_TYPE.A, "", 3000, 0, 1);
      if (e) {
        ref += `
          <a tfc='${tfc}' tfh='${tfh}' target="_blank" class="co-form" href="${e}">
            Learn more
            <img alt="arrow" src="${arrow}" />
          </a>
        `
      }
    });

    const param = this.paramName ? ` param="${this.paramName}"` : "";

    const tfc = Track.genNormalTrack("", "requirement", "checkbox-" + this.id, ELEMENT_TYPE.INPUT, "", 3000, 0, 1);
    const tfh = Track.genNormalTrack("", "requirement", "checkbox-" + this.id, ELEMENT_TYPE.INPUT, "", 3000, 0, 1);

    html = `
      <tr class="item${!this.checked ? " not-apply" : ""}${latest ? " latest" : ""}">
        <td${translate}>${this.label}${hint}</td$>
        <td${translate}>${detail}${form}</td$>
        <td${translate}>${ref}</td$>
        <td>
          <input${param} tfc='${tfc}' tfh='${tfh}' name="${this.name}"${this.checked ? " checked" : ""} type="checkbox">
        </td>
      </tr>
    `;
    return html;
  }
}